import { BaseLayer } from "./BaseLayer";

export class ParkingSpotsLayer extends BaseLayer {
  constructor(map, apiUrl, exportUrl, csrfToken) {
    super(map, apiUrl, exportUrl, csrfToken);
    this.toggleButton = document.getElementById("button-map-psr");
    this.markerTitle = "PSR Location";
    this.layerName = "ParkingSpotsLayer";
    this.exportName = "PSR Locations";
    this.create();
  }

  showInfoWindow(event) {
    const feature = event.feature;

    const certificationLevelName =
      feature.getProperty("certification_level_name") === undefined
        ? "N/A"
        : "" + feature.getProperty("certification_level_name");

    const listItems = [
      '<i class="fa-li fa fa-parking"></i> Name: ' + feature.getProperty("parking_place_name"),
      '<i class="fa-li fa fa-headset"></i> Company: ' + feature.getProperty("parking_place_operator_name"),
      '<i class="fa-li fa fa-truck"></i> Truck Parking Places: ' + feature.getProperty("number_truck_parking_places"),
      '<i class="fa-li fa fa-file"></i> Security Level: ' + certificationLevelName,
    ];

    this.createInfoWindow(listItems, event);
  }
}
